/**
 * Value sets the HOST closes but `@sites/entity-core` stores as a plain string.
 *
 * The entity package is framework-free on purpose: it persists host enum literals as literals, which
 * is right for a store and wrong for the surface a model writes through. Nothing between the two
 * refuses a wrong name — it validates, saves, and reaches the CSS as a rule that does nothing. Found
 * three times over now (the block's contour and scroll effect, the column's scroll effect, the
 * image's contour), each time as a silently dead setting rather than an error, so the sets live here
 * once instead of being retyped beside each field.
 *
 * Keep each in step with the host enum named beside it. They are small and closed; a value added
 * there and missed here is refused with a named reason, which is the safe direction.
 */

/** `ELineStyle` in `common/enums/line-style.enum.ts`. */
export const LINE_STYLES = ['solid', 'dashed', 'dotted'] as const;

/** `EScrollEffect` in `common/enums/scroll-effect.enum.ts`. */
export const SCROLL_EFFECTS = ['fixed', 'parallax'] as const;
